"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPaper = StyledPaper;
exports.default = TitledPaper;
var _material = require("@mui/material");
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _PaperTitle = _interopRequireDefault(require("../PaperTitle"));
var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    actions: {
      flexShrink: 0
    },
    paper: {
      borderRadius: '12px',
      display: 'block',
      marginBottom: theme.spacing(2),
      padding: theme.spacing(2)
    },
    title: {
      display: 'inline-flex',
      flexGrow: 99
    },
    titleContainer: {
      flexShrink: 1,
      minWidth: 1,
      overflowWrap: 'break-word'
    }
  };
});
function StyledPaper(_ref) {
  var children = _ref.children,
    className = _ref.className,
    id = _ref.id;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_material.Paper, {
    className: (0, _classnames.default)(classes.paper, className),
    id: id,
    square: true
  }, children);
}
function TitledPaper(_ref2) {
  var actions = _ref2.actions,
    children = _ref2.children,
    className = _ref2.className,
    id = _ref2.id,
    title = _ref2.title,
    titleKey = _ref2.titleKey;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(StyledPaper, {
    className: className,
    id: id
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    alignItems: "center",
    container: true,
    spacing: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    alignItems: "center",
    container: true,
    spacing: 2,
    wrap: "nowrap"
  }, (title || titleKey) && /*#__PURE__*/_react.default.createElement(_material.Grid, {
    className: classes.titleContainer,
    item: true,
    xs: true
  }, titleKey && /*#__PURE__*/_react.default.createElement(_PaperTitle.default, {
    className: classes.title,
    id: "".concat(id, "Title"),
    titleKey: titleKey
  }), title), actions && /*#__PURE__*/_react.default.createElement(_material.Grid, {
    className: classes.actions,
    item: true,
    xs: "auto"
  }, actions))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12
  }, children)));
}